module.exports = __webpack_public_path__ + "static/gmarket-2f9aa13584dec6a00092555d8c6dc4e2.png";